import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { copyToClipboard } from 'src/app/core/utils/util';

@Directive({
  selector: '[copyToClipboard]',
  standalone: true,
})
export class CopyToClipboardDirective implements OnDestroy {
  tooltipTitle: string = this.translate.instant('messages.clipboard.message');
  @Input() placement: string = 'top';
  //used for copy domainLink in users and organizations menus
  @Input() copyValue: string;
  tooltip: HTMLElement;

  offset = 10;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private translate: TranslateService
  ) {}

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltip) {
      this.show();
    }
  }

  @HostListener('click') onClick() {
    this.tooltip.innerText = this.translate.instant(
      'messages.clipboard.copied'
    );
    this.setPosition();
    this.copyValueToClipboard(
      this.copyValue ? this.copyValue : this.el.nativeElement.textContent
    );
    // setTimeout(() => {
    //   this.hide();
    // }, 1000);
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltip) this.hide();

    this.tooltipTitle = this.translate.instant('messages.clipboard.message');
  }

  show() {
    this.create();
    this.setPosition();
    this.renderer.addClass(this.tooltip, 'ng-tooltip-show');
  }

  hide() {
    this.renderer?.removeClass(this.tooltip, 'ng-tooltip-show');
    this.renderer?.removeChild(document.body, this.tooltip);
    this.tooltip = null;
  }

  create() {
    this.tooltip = this.renderer.createElement('span');
    if (
      this.el.nativeElement.textContent != '_' &&
      this.el.nativeElement.textContent != '' &&
      this.el.nativeElement.textContent != '-'
    ) {
      this.renderer.appendChild(
        this.tooltip,
        this.renderer.createText(this.tooltipTitle) // textNode
      );

      this.renderer.appendChild(document.body, this.tooltip);
      // this.renderer.appendChild(this.el.nativeElement, this.tooltip);

      this.renderer.addClass(this.tooltip, 'ng-tooltip');
      this.renderer.addClass(this.tooltip, `ng-tooltip-${this.placement}`);
    }
  }

  setPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();
    const tooltipPos = this.tooltip.getBoundingClientRect();
    const scrollPos =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    let top, left;

    if (this.placement === 'top') {
      top = hostPos.top - tooltipPos.height - this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.placement === 'bottom') {
      top = hostPos.bottom + this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.placement === 'left') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.left - tooltipPos.width - this.offset;
    }

    if (this.placement === 'right') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.right + this.offset;
    }
    this.renderer.setStyle(this.tooltip, 'top', `${top + scrollPos}px`);
    this.renderer.setStyle(this.tooltip, 'left', `${left}px`);
  }

  copyValueToClipboard(value: any) {
    copyToClipboard(value);
  }

  ngOnDestroy() {
    var tooltip = document.querySelector('.ng-tooltip-show');
    if (tooltip) tooltip.remove();
    this.tooltip = null;
  }
  
}
